var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"px-3 py-2 rounded-lg m-1"},[_c('ColorPicker',{attrs:{"namespace":_vm.namespace,"alwaysOpen":true},on:{"colorChanged":_vm.colorChanged},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }